import { useState } from "react";
import {
  HiTrendingUp,
  HiUserGroup,
  HiLightningBolt,
  HiChevronDown,
  HiChevronUp,
} from "react-icons/hi";
import { FaTrophy } from "react-icons/fa";

const KeyHighlights = () => {
  const [expandedCard, setExpandedCard] = useState(null);

  const toggleCard = (index) => {
    setExpandedCard(expandedCard === index ? null : index);
  };

  const impacts = [
    {
      icon: <HiTrendingUp className="text-4xl text-cyan-500" />,
      title: "System Stability",
      metric: "70%",
      description: "Reduction in support tickets for legacy government systems",
      detail: "Transformed EWP-v1 from daily issues to weekly stability",
    },
    {
      icon: <HiUserGroup className="text-4xl text-cyan-500" />,
      title: "Technical Leadership",
      metric: "12 Months",
      description: "Lead Developer role achieved within first year",
      detail: "From frontend focus to full-stack architecture leadership",
    },
    {
      icon: <HiLightningBolt className="text-4xl text-cyan-500" />,
      title: "API Integrations",
      metric: "3+",
      description: "National Integrations (National ID, Revenue, Trade)",
      detail: "Government-level API contracts and system integrations",
    },
    {
      icon: <FaTrophy className="text-4xl text-cyan-500" />,
      title: "Academic Excellence",
      metric: "3.97/4.00",
      description: "CGPA with multiple awards and recognitions",
      detail: "Top graduate with comprehensive achievement record",
      expandable: true,
      expandedContent: [
        "1st Place - Computer Engineering Department (Medalist)",
        "Student of the Year 2024 (Trophy Winner)",
        "1st Place - Final Year Project Award",
        "Highest National Exit Exam Score (81)",
      ],
    },
  ];

  return (
    <div name="impact" className="w-full bg-[#0a192f] text-gray-300 py-16">
      <div className="max-w-[1200px] mx-auto px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            Key Highlights
          </h2>
          <p className="text-[#8892b0] text-lg max-w-2xl mx-auto">
            One year at E-LMIS: From frontend to systems architecture,
            delivering measurable impact on national-level platforms
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {impacts.map((impact, index) => (
            <div
              key={index}
              className="bg-[#112240] p-6 rounded-xl border border-cyan-600 border-opacity-20 hover:border-opacity-50 transition-all duration-300 hover:shadow-lg hover:shadow-cyan-600/20 group"
            >
              <div className="text-center space-y-4">
                <div className="flex justify-center group-hover:scale-110 transition-transform duration-300">
                  {impact.icon}
                </div>

                <h3 className="text-xl font-bold text-white">{impact.title}</h3>

                <div className="text-3xl font-bold text-cyan-500 mb-2">
                  {impact.metric}
                </div>

                <p className="text-[#8892b0] font-medium mb-3">
                  {impact.description}
                </p>

                <p className="text-[#8892b0] text-sm leading-relaxed">
                  {impact.detail}
                </p>

                {impact.expandable && (
                  <>
                    <button
                      onClick={() => toggleCard(index)}
                      className="flex items-center justify-center gap-2 text-cyan-400 hover:text-cyan-300 transition-colors duration-300 mx-auto mt-3"
                    >
                      <span className="text-sm font-medium">
                        {expandedCard === index ? "Show Less" : "View Details"}
                      </span>
                      {expandedCard === index ? (
                        <HiChevronUp className="text-lg" />
                      ) : (
                        <HiChevronDown className="text-lg" />
                      )}
                    </button>

                    {expandedCard === index && (
                      <div className="mt-4 pt-4 border-t border-cyan-600 border-opacity-20 space-y-2">
                        {impact.expandedContent.map((item, idx) => (
                          <div
                            key={idx}
                            className="flex items-start gap-2 text-left"
                          >
                            <span className="text-cyan-500 mt-1 text-sm">
                              •
                            </span>
                            <p className="text-[#8892b0] text-sm">{item}</p>
                          </div>
                        ))}
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-[#8892b0] text-lg italic">
            "I consistently leave systems better than I found them"
          </p>
        </div>
      </div>
    </div>
  );
};

export default KeyHighlights;
